export default __webpack_public_path__ + "static/media/loader.f69fb800.svg";